/**
 * Sets up the routing for all admin views relating to the User resource.
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect, Switch, withRouter } from 'react-router-dom';

// import global components
import Base from "../../global/components/BaseComponent.js.jsx";
import YTRoute from '../../global/components/routing/YTRoute.js.jsx';

// import contentModule admin views
import AdminBuildContentModule from './views/AdminBuildContentModule.js.jsx';


class ContentModuleBuildRouter extends Base {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Switch>
        <YTRoute
          role="admin"
          exact
          path="/cm-builder/:contentModuleId"
          component={AdminBuildContentModule}
        />
      </Switch>
    )
  }
}

export default withRouter(ContentModuleBuildRouter);



// WEBPACK FOOTER //
// modules/contentModule/ContentModuleBuildRouter.js.jsx